import { render, staticRenderFns } from "./NewBusinessLogin.vue?vue&type=template&id=f30e0e9a&scoped=true&"
import script from "./NewBusinessLogin.vue?vue&type=script&lang=js&"
export * from "./NewBusinessLogin.vue?vue&type=script&lang=js&"
import style0 from "./NewBusinessLogin.vue?vue&type=style&index=0&id=f30e0e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30e0e9a",
  null
  
)

export default component.exports